import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'

const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    <Link to={`/kepegawaian/pengajuan_wfh.html`}>
                                        <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                    </Link>
                                </div>
                                <CardTitle>Daftar Pengajuan WFH Bawahan</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Pengajuan WFH Bawahan
                                </CardSubtitle>
                                <hr />
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        NIP
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_nip
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        Nama
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_full_name
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        Jabatan
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_current_position_name
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        Unit Kerja
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_current_work_unit_name
                                        }
                                    </Col>
                                </Row>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView